import React from 'react';
import { Button as BootstrapButton } from 'react-bootstrap';
import { Button as ButtonStyle } from '../../theme/styles';
import './Button.css';

/**
   * @function Button
   * @description Wrapper for Bootstrap button
   * @param {String} id id attribute for button
   * @param {String} icon feather icon, generally, to display left of the button content
   * @param {String} className additional CSS classes to add to the button
   * @param {String} variant one of: 'primary', 'secondary', 'destructive', 'menu', 'icon', 'label', 'label-cancel', 'action', 'action-remove'
   * @param {String} type one of: button', 'reset', 'submit'
   * @param {boolean} disabled should the button be disabled
   * @param {String} content text, generally, to display inside of the button
   * @param {String} contentStyle additional CSS styles to add to the button
   * @param {Function} onClick callback when button is clicked on
   * @param {String} testId test id for the button, should be the full `data-testid` attribute created by the `testID` helper
   * @returns {JSX.Element} JSX.Element
   */
export class Button extends React.PureComponent {
    buttonClick = (event) => {
        event.preventDefault();
        this.props.onClick(event);
    };

    render() {
        const {
            id,
            icon,
            className,
            variant,
            type,
            disabled,
            content,
            contentStyle,
            onClick,
            testId,
            tabIndex = 0,
        } = this.props;

        const style = { ...ButtonStyle, ...contentStyle };
        return (
            <BootstrapButton
                data-testid={testId || id}
                id={id}
                variant={variant}
                type={type}
                style={style}
                className={className}
                disabled={disabled}
                onClick={onClick ? this.buttonClick : null}
                tabIndex={tabIndex}
            >
                {icon}
                {content}
            </BootstrapButton>
        );
    }
}

export default Button;
